export class DestinationEndpoint {
  destinationEndpointId: number;
  endpointName: string;
  endpointDescription: string;
  fastFetchEnabled: boolean;
  displayName: string;
}

export function getEndpointName(destinationEndpointId: number, destinations: DestinationEndpoint[]): string {
  const endpointName = destinations.find(d => d.destinationEndpointId == destinationEndpointId).endpointName ?? '';
  return endpointName;
}
